// Step 3 Tactic Configuration - Alpine.js Component
// Handles individual tactic configuration forms

document.addEventListener('alpine:init', () => {
  Alpine.data('campaigns_step3_tactic_config_x_data', () => ({
    tacticConfig: {},
    formData: {},
    
    init() {
      // Get tactic configuration data from the template ref
      const tacticTemplate = this.$refs.tacticData;
      
      if (tacticTemplate) {
        this.tacticConfig = JSON.parse(tacticTemplate.textContent);
      } else {
        console.warn('Tactic configuration template not found');
      }
      
      // Initialize form data
      this.initializeFormData();
    },
    
    // Initialize form data structure
    initializeFormData() {
      this.formData = {
        rss_feed: '',
        show_description: '',
        brand_guidelines: null,
        targeting: {
          gender: '',
          age_range: '',
          household_income: '',
          location: '',
          keywords: '',
          audience_interests: ''
        },
        episodes: []
      };
    },
    
    // Handle file upload for brand guidelines
    handleBrandGuidelinesUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.brand_guidelines = file;
      }
    },
    
    // Handle episode selection
    handleEpisodeSelection(episodeId, rowIndex) {
      if (episodeId) {
        // Find the episode data and populate the row
        this.populateEpisodeRow(episodeId, rowIndex);
      }
    },
    
    // Populate episode row with data
    populateEpisodeRow(episodeId, rowIndex) {
      // This would typically fetch episode data from the backend
      // For now, we'll just update the form data
      if (!this.formData.episodes[rowIndex]) {
        this.formData.episodes[rowIndex] = {};
      }
      this.formData.episodes[rowIndex].episode_id = episodeId;
      
      // Update the release date field (this would be populated from episode data)
      const releaseDateInput = document.querySelector(`input[data-episode-row="${rowIndex}"][data-field="release_date"]`);
      if (releaseDateInput) {
        releaseDateInput.value = '[auto populate when episode is chosen]';
      }
    },
    
    // Add new episode row
    addEpisodeRow() {
      if (this.formData.episodes.length < 5) {
        this.formData.episodes.push({});
        this.renderEpisodeRows();
      } else {
        alert('Maximum of 5 episodes allowed');
      }
    },
    
    // Remove episode row
    removeEpisodeRow(index) {
      this.formData.episodes.splice(index, 1);
      this.renderEpisodeRows();
    },
    
    // Render episode rows (this would be called when adding/removing rows)
    renderEpisodeRows() {
      // This is a simplified version - in a real implementation,
      // you might want to use Alpine.js x-for or similar
    },
    
    // Refresh RSS feed
    refreshRssFeed() {
      // This would typically make an API call to refresh the RSS feed
      // You could show a loading state here
    },
    
    // Save form data
    saveFormData() {
      // This would typically make an API call to save the form data
      // and update the campaign_tactic record
    },
    
    // Validate form
    validateForm() {
      const requiredFields = [
        'targeting.gender',
        'targeting.age_range', 
        'targeting.household_income',
        'targeting.location'
      ];
      
      let isValid = true;
      const errors = [];
      
      requiredFields.forEach(field => {
        const value = this.getNestedValue(this.formData, field);
        if (!value || value.trim() === '') {
          isValid = false;
          errors.push(`${field.replace('targeting.', '')} is required`);
        }
      });
      
      if (this.formData.episodes.length === 0) {
        isValid = false;
        errors.push('At least one episode must be selected');
      }
      
      if (!isValid) {
        alert('Please fill in all required fields: ' + errors.join(', '));
      }
      
      return isValid;
    },
    
    // Helper to get nested object values
    getNestedValue(obj, path) {
      return path.split('.').reduce((current, key) => current && current[key], obj);
    },
    
    // Submit form
    submitForm() {
      if (this.validateForm()) {
        this.saveFormData();
        // Redirect or show success message
      }
    }
  }));
});
